import * as React from "react";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";
import ReadService from "../../service/read";
import Wait from "../wait";

export default class CCROAddNewLayerPane extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            srid: 0,
            villages: []
        }



        this.loadData = this.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect =this.generalSelect.bind(this)
    }

    handleChanges=(e)=>{this.setState({[e.target.name]:e.target.value})}
    handleChangeFile=e=>{this.setState({ zipped:e.target.files[0] })}

     generalSelect(data,name) {
        //console.log(data)
         this.setState({
             [name]: data.value
         })


     }

     componentDidMount() {
        try {
            Wait.show('Fetching Villages....')
            ReadService.fetchProjectVillages(this.props.project.id).then(r=>{

                this.setState({
                    villages:r.data.results
                })

                Wait.dismiss()

            })
        }catch (e) {

        }
     }

    render() {
        return(<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding:0}}>

                <table style={{width:'94%',margin:'2%'}}>
                    <tbody>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Select Village</td>
                    </tr>
                    <tr>
                         <td>
                              <select style={{width:'100%'}} onChange={this.handleChanges} name={'village'}>
                                  <option value={undefined}>- Choose One -</option>
                                  {this.state.villages.map((v,i)=>{
                                      return(<option value={v.value}>{v.label}</option>)
                                  })}
                              </select>
                         </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Layer Type</td>
                    </tr>
                    <tr>
                        <td>
                            <select style={{width:'100%'}} onChange={this.handleChanges} name={'layer'}>
                                <option value={undefined}>- Choose One -</option>
                                <option value={'boundary'}>Village Boundary</option>
                                <option value={'hamlet'}>Hamlet Boundary</option>
                                <option value={'land_use'}>Village Land Use</option>
                                <option value={'other'}>Conceptual Diagram</option>
                                <option value={'point'}>Beacons</option>
                                <optgroup label={'Restricted Areas'}>
                                    <option value={'restricted'}>Reserved Areas</option>
                                    <option value={'restricted'}>Surveyed Areas</option>
                                </optgroup>
                            </select>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Shapefile Description - Column Name</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'text'} style={{width:'99%'}} name={'name'} onChange={this.handleChanges}/>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Projection ( SRID )</td>
                    </tr>
                    <tr>
                        <td>
                             <select defaultValue={this.state.srid} style={{width:'100%'}} onChange={this.handleChanges} name={'srid'}>
                                <option value={0}>- Choose One -</option>
                                 <option>32737</option>
                                 <option>32736</option>
                                 <option>4326</option>
                            </select>
                        </td>
                    </tr>


                    <tr>
                         <td className={'label'} style={{width:'99%'}}>Layer Description</td>
                    </tr>
                    <tr>
                        <td>
                            <textarea style={{width:'99.5%'}} onChange={this.handleChanges} name={'description'}/>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Shapefile</td>
                    </tr>
                    <tr>
                         <td>
                             <input type={'file'} accept=".zip,.ZIP" name={'zipped'} onChange={this.handleChangeFile}/>
                         </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign:'center',width:'100%',float:'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Save
                    </button>
                     <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>
                        <span className={'fa fa-times'}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    loadData(){

        try{
            Wait.show('Fetching Villages....')
            ReadService.fetchProjectVillages(this.props.project.id).then(r => {
                Wait.dismiss()
                this.setState({
                    villages:r.data.results
                })
            })
        }catch (e) {
            console.log(e)
        }

        //console.log('here,...')
        //console.log(this.props.project)
    }


    submit(){
        try{

            let layer = this.state.layer
            let srid = this.state.srid
            let name = this.state.name
            let description = this.state.description
            let village = this.state.village

            if (village===undefined){
                alert('No Village')
                return
            }
            if (layer===undefined){
                alert('No Layer')
                return
            }
            if (srid===undefined){
                alert('No Projection  ( SRID )')
                return
            }
            if (name===undefined){
                alert('No Shapefile Column Name')
                return
            }
            if (description===undefined){
                alert('No Layer Description')
                return
            }

            const formData = new FormData()
            formData.append('zipped',this.state.zipped)
            formData.append('extra',JSON.stringify({
                villageId:village,
                layer:layer,
                srid:srid,
                name:name,
                description:description,
                projectId:this.props.project.id
            }))

            Wait.show('Creating Layer...')
            CreateService.createLayer(formData).then(d=>{
                Wait.dismiss()
                if (d.data.status===0){
                    alert(d.data.message)
                    return
                }
                this.props.loadData()
                PopDetail.dismiss()
            })




        }catch (e) {
             alert(e)
        }
    }


}